exports.polyfill = Component => Component
